<h1 mat-dialog-title class="p-2 text-center">Connexion en tant qu'un autre utilisateur </h1>
<div mat-dialog-content class="p-3">

    <div class="row">
        <mat-form-field class="col mb-3">
            <input matInput [(ngModel)]="Model" placeholder="Email" [formControl]="ValidEmail" required>
            @if (!ValidEmail.valid) {
                <mat-error>
                    Email incorrect
                </mat-error>
            }
        </mat-form-field>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()">
            Ajouter
        </button>
    </div>
</div>